import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { useTranslation } from "@coworker/locales";
import { isLoading, LOADING, Loading } from "../loading";
import { useAllTaskTypes } from "./useTaskTypes";
import { Task } from "../types/Task";

export const useCreateTitle = (
  task: Record<string, unknown> | undefined | Loading
): string | Loading => {
  const { t } = useTranslation();

  const { data: taskTypes, isLoading: isTaskTypesLoading } = useAllTaskTypes();

  const titleCreator = taskTypes?.find(
    (type) => type.id === (task as Task)?.task_type_id
  )?.title_creator;

  if (
    isLoading(task) ||
    isTaskTypesLoading ||
    !titleCreator ||
    task === undefined
  ) {
    return LOADING;
  }

  const { id, props } = titleCreator;

  switch (id) {
    case "field-title-creator": {
      const { field } = props;
      return getByPath(task, field);
    }
    case "translation-title-creator": {
      const { translationKey } = props;
      return t(translationKey);
    }
  }
};
